import { gql } from '@apollo/client';
import POST_SUMMARY_FIELDS_FRAGMENT from './PostSummaryFields';
import TOPIC_SUMMARY_FIELDS_FRAGMENT from './TopicSummaryFields';

export default gql`
  fragment ProvisionFields on Provision {
    id
    name
    favoritePosts {
      ...PostSummaryFields
    }
    favoriteTopics {
      ...TopicSummaryFields
    }
    topics {
      ...TopicSummaryFields
    }
    posts {
      ...PostSummaryFields
    }
    secret
    type
    urlEnabled
    isSsoDefault
  }
  ${POST_SUMMARY_FIELDS_FRAGMENT}
  ${TOPIC_SUMMARY_FIELDS_FRAGMENT}
`;
